export default __webpack_public_path__ + "static/media/Blaq.0dabb304.webp";